import React, { Component } from 'react';
import PropTypes from 'prop-types';


import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../Actions/Modal';

import './../modal.css';

class ModalContainer extends Component {


    render() {
        return (
            <>
                {
                    this.props.open &&
                    <div className="modal-back" >
                        <div className="modal">
                            {
                                this.props.children
                            }
                        </div>
                    </div>
                }
            </>
        )
    }
}

ModalContainer.propTypes = {
    children: PropTypes.element.isRequired,
}

function mapStateToProps(state, props) {
    // console.log(state);
    return {
        open: state.modal.open,
        children: state.modal.children
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);